import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { EnhancedMainLayout } from '@/components/layout/EnhancedMainLayout'
import { initializeSampleData } from '@/utils/seedData'
import './index.css'

function App() {
  useEffect(() => {
    // 初始化示例数据
    initializeSampleData()
  }, [])

  return <EnhancedMainLayout />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)